import PropTypes from 'prop-types'
import classNames from 'classnames'

import ProfileAvatar from './ProfileAvatar'

import classes from './AvatarStack.module.scss'

const AvatarStack = ({ users, className, interactive = true }) => (
  <div className={classNames(classes.members, className)}>
    {users.map((user, idx) => (
      <div
        key={user.id}
        className={interactive ? classes.avatar : classes.avatarStatic}
        style={{ zIndex: 50 - idx, marginLeft: idx === 0 ? 0 : '-16px' }}
      >
        <ProfileAvatar student={user} interactive={interactive} />
      </div>
    ))}
  </div>
)

AvatarStack.propTypes = {
  users: PropTypes.arrayOf(PropTypes.object).isRequired,
  className: PropTypes.string,
  interactive: PropTypes.bool,
}

export default AvatarStack
